module.exports = __webpack_public_path__ + "ae43691ed4be78bb6bf30d9bc81fe337.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1024.webp
// module id = 612
// module chunks = 0